export default __webpack_public_path__ + "static/media/116-cash.77fb8bb1.svg";